import {
    Inject,
    ISimpleControllerConfiguration,
    ModelEvents,
    SimpleBaseController
} from "@denishussar/html5-game-engine";
import {Container, Point, Sprite, Texture} from "pixi.js";
import { ScrollBarController } from "./ScrollBarController";
import {GameModel} from "../../Models/GameModel";
import {GameEvent} from "../../Constants/GameEvent";
import {GameLogic} from "../../Logic/GameLogic";

export interface IScrollPaneController {
    scrollBar: ScrollBarController;
    onused: (value: number) => {}
}

export class ScrollPaneController extends SimpleBaseController {
    $model: any;

    public isInScroll: boolean = false;

    private _bounds: {width: number, height: number};
    private _mask: Sprite;
    private _content: Container;
    private _isCursorDown: boolean;
    private _startPoint?: number;
    private _timer;

    public constructor(
        @Inject private _options: IScrollPaneController,
        @Inject private modelEvents: ModelEvents,
        @Inject protected model: GameModel,
        @Inject protected _gameLogic: GameLogic,
    ) {
        super('ContainerController');
    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        return <ISimpleControllerConfiguration>{};
    }

    protected onInitialize(): void {
        this._bounds = {width: 300, height: 300};
        window.addEventListener('wheel', this.handleMouseWheel);

        this.display.interactive = true;
        this.display.on('mousedown', this.handleMouseDown);
        this.display.on('touchstart', this.handleMouseDown);
        this.display.on('mouseup', this.handleMouseUp);
        this.display.on('touchend', this.handleMouseUp);
        this.display.on('mousemove', this.handleMouseMove);
        this.display.on('touchmove', this.handleMouseMove);
    }

    public setSize(width: number, height: number): void {
        this._bounds.width = width;
        this._bounds.height = height;
    }

    public setContentPosition(y: number): number {
        this.logScroll();
        if (!this._content) {
            return y;
        }

        if (y < this._bounds.height - this._content.height) {
            y = this._bounds.height - this._content.height
        }
        if (y > 0) {
            y = 0;
        }

        this._content.y = y;

        return y;
    }

    protected onDestroy() {
        window.removeEventListener('wheel', this.handleMouseWheel)
        super.onDestroy();
    }

    private tID?: number;
    private logScroll(): void {
        if (this.tID) {
            clearTimeout(this.tID);
        }

        this.tID = setTimeout(() => {
            this.tID = undefined;
            this.modelEvents.dispatch(this.model, GameEvent.scroll, {
                popupName: this._gameLogic.modalsManager.getCurrentKey()
            })
        }, 500) as any as number;
    }

    private setMask(): void {
        if (this._mask) {
            this.display.mask = null;
            this.display.removeChild(this._mask);
        }

        this._mask = new Sprite(Texture.WHITE);
        this._mask.width = this._bounds.width;
        this._mask.height = this._bounds.height;
        this.display.mask = this._mask;
        this.display.addChild(this._mask);
    }

    public set content(value: Container | undefined) {
        this._content = value;
        this.display.removeChildren(0);

        if (!this._content) {
            return;
        }

        this.display.addChild(this._content);

        this.setMask();
    }

    public get content(): Container {
        return this._content;
    }

    private handleMouseDown = (e) => {
        this._isCursorDown = true;
        this._startPoint = e.data.global.y;

        this._timer = setTimeout(() => {
            this.isInScroll = true;
        }, 500);
    }
    private handleMouseUp = () => {
        this._isCursorDown = false;
        this.isInScroll = false;
        this._startPoint = undefined;

        if (this._timer) {
            clearTimeout(this._timer);
        }
    }
    private handleMouseMove = (e) => {
        if (!this._content) return;
        if (!this._isCursorDown || !this._startPoint) return;

        const deltaY = this._startPoint - e.data.global.y;
        if (deltaY > 1 || deltaY < -1) {
            this.isInScroll = true;
        }
        this._startPoint = e.data.global.y;
        // console.log(deltaY, this._startPoint.y);
        const y = this.setContentPosition(this._content.y - deltaY);

        if (this._options.onused) {
            this._options.onused(y);
        }
    }

    private handleMouseWheel = (e) => {
        if (!this._content) {
            return;
        }
        let y = this.setContentPosition(this._content.y - e.deltaY);

        if (this._options.onused) {
            this._options.onused(y);
        }
    }
}